import isAgentUser from './isAgentUser'

export default function isCacheDisabled (src = window) {
  const agent = isAgentUser(src)
  const noCache = /nocache(?!=false)/i.test(src.location.search)
  return agent || noCache
}
